@if (!incidentService.DriverIncident) {
    <div class="buttonDiv buttonDivNewIncident" (click)="onClickNewBreakdown()">
        <nz-spin [nzSpinning]="isLoading">
            <h1>NEW BREAKDOWN</h1>
            <svg xmlns="http://www.w3.org/2000/svg" height="50%" viewBox="0 -960 960 960" width="50%" fill="orange">
                <path d="M40-280v-160h328L120-636v116H40v-240h40l440 242v-282h200l200 240v280H820q0 50-35 85t-85 35q-50 0-85-35t-35-85H360q0 50-35 85t-85 35q-50 0-85-35t-35-85H40Zm200 60q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm460 0q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17ZM600-560h216L682-720h-82v160Z"/>
            </svg>
        </nz-spin>
    </div>
}
@else {
<nz-steps nzDirection="vertical" [nzCurrent]="0" >
    <nz-step nzTitle="Log New Breakdown" nzDescription="Completed" [nzStatus]="incidentService.DriverIncident.incidentId > 0 ? 'finish' : 'wait'"></nz-step>
    <nz-step nzTitle="Get Location" nzDescription="Sent from Driver" [nzStatus]="incidentService.DriverIncident.location ? 'finish' : 'wait'"></nz-step>
    <nz-step nzTitle="Accepted by Fleet Controller" [nzDescription]="incidentService.DriverIncident.incidentOperators.length > 0 ? 'Assigned to ' + incidentService.DriverIncident.incidentOperators[0].name : 'Awaiting Operator'" [nzStatus]="incidentService.DriverIncident.incidentOperators.length > 0 ? 'finish' : 'wait'"></nz-step>
    <nz-step nzTitle="Mechanic Assigned" nzDescription="Awaiting Operator" nzStatus="wait"></nz-step>
    <nz-step nzTitle="Mechanic Dispatched" nzDescription="ETA: Unknown" nzStatus="wait"></nz-step>
    <nz-step nzTitle="Mechanic Arrived" nzDescription="Awaiting Mechanic" nzStatus="wait"></nz-step>
    <nz-step nzTitle="Mechanic Resolved" nzDescription="Awaiting Mechanic" nzStatus="wait"></nz-step>

</nz-steps>
}

<nz-modal
      nzCentered
      [(nzVisible)]="isNewIncidentModalVisible"
      [nzTitle]=undefined
      (nzOnCancel)="isNewIncidentModalVisible = false;"
      (nzOnOk)="onClickAddNewIncident()"
    >
      <ng-container *nzModalContent>
        @if (breakdown.location) {        
            <nz-result
                nzStatus="info"
                nzTitle="REPORT BREAKDOWN"
                >
                <div nz-result-extra>
                    <h3><strong>Current Location:</strong></h3>
                    <div>Lat: {{ breakdown.location!.latitude }}</div>
                    <div>Lon: {{ breakdown.location!.longitude }}</div>
                </div>
            </nz-result>
        }
        @else {
            <nz-result
                nzStatus="warning"
                nzTitle="REPORT BREAKDOWN"
                nzSubTitle="Can not determine current location"
            ></nz-result>

        }
        <div style="text-align: center;">
            <h3><strong>Breakdown Type</strong></h3>
            <button nz-button [nzType]="breakdown.incidentType === incidentType.Tyre ? 'primary' : 'default'" (click)="onSelectIncidentType(incidentType.Tyre)">Tyre</button>
            <button nz-button [nzType]="breakdown.incidentType === incidentType.Mechanical ? 'primary' : 'default'" (click)="onSelectIncidentType(incidentType.Mechanical)">Mechanical</button>
            <!-- <button nz-button [nzType]="incident.incidentType === incidentType.Both ? 'primary' : 'default'" (click)="onSelectIncidentType(incidentType.Both)">Both</button> -->
        </div>
      </ng-container>
    </nz-modal>